import { FontWeights, Text } from "@flat-ui";
import { Stack } from "@mui-wrapper";
import { UlmContainer } from "@components/ulm/ulm-container";
import PasswordChangedIcon from "@assets/icons/password-changed_60px.svg?react";
import { UlmButton } from "@components/ulm/ulm-button";
import { useNavigate } from "react-router-dom";
import { PageTitle } from "@components/common/page-title";

/**
 * Component used to display a confirmation screen to users
 * after they have successfully changed their password.
 */
export function PasswordChangeSuccess(): JSX.Element {
  const navigate = useNavigate();

  return (
    <UlmContainer>
      <PageTitle>Password changed</PageTitle>

      <Stack
        sx={{
          width: "106px",
          height: "106px",
          bgcolor: "surfaces.secondary",
          alignItems: "center",
          justifyContent: "center",
          borderRadius: "50%",
          marginTop: "25px",
        }}
      >
        <PasswordChangedIcon />
      </Stack>

      <Text
        variant="bodyL"
        component="p"
        sx={{
          color: "text.secondary",
          fontWeight: FontWeights.SemiBold,
          marginTop: "25px",
          textAlign: "center",
        }}
      >
        The password for your account has been successfully changed
      </Text>
      <UlmButton
        onClick={() => void navigate("/")}
        sx={{
          marginTop: "42px",
        }}
      >
        Continue
      </UlmButton>
    </UlmContainer>
  );
}
